import React, { Component } from 'react';
import { Dialog, DialogCloseButton } from '../Dialog';
import AddSessionForm from '../AddSessionForm';
import './styles.scss';

class AddSessionDialog extends Component {
	render() {
		const { closeDialog, onSessionCreated } = this.props;
		return (
			<Dialog className="AddSessionDialog" closeDialog={closeDialog}>
				<DialogCloseButton closeDialog={closeDialog} />
				<AddSessionForm onSessionCreated={onSessionCreated} />
			</Dialog>
		);
	}
}

export default AddSessionDialog;
